import { useEffect, useState } from 'react';

/* Atrasa a propagação de `value` em `delayMs` — evita uma chamada de backend por
   tecla na busca. */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
